// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sop-container[data-v-06f51c88] {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.sop-container .content-col[data-v-06f51c88] {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n", ""]);
// Exports
module.exports = exports;
